'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const Formatters=require('../../../../../dist-es6/client/formatters');
const DateBucketType=require('../../../../../dist-es6/client/features/fleetInsight/components/fleetIncidents/incidentBucketTypes').Types.Date;
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseFleetInsightSubViewController=require('../../../../../dist-es6/client/features/fleetInsight/components/baseFleetInsightSubViewController');let

FleetIncidentsDirective=function(_BaseControllerBacked){_inherits(FleetIncidentsDirective,_BaseControllerBacked);function FleetIncidentsDirective(){_classCallCheck(this,FleetIncidentsDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(FleetIncidentsDirective,[{key:'templateUrl',get:function()
{
return'/templates/features/fleetInsight/components/fleetIncidentsTemplate';
}},{key:'objectBindings',get:function()

{
return['displayInterval'];
}},{key:'controller',get:function()

{
return FleetIncidentsDirectiveController;
}},{key:'$inject',get:function()

{
return[
'$timeout',
'$state',
'$scope',
'fleetIncidentsDataService',
'uncaughtErrorHandler',
'groupTreeService'];

}}]);return FleetIncidentsDirective}(BaseControllerBackedDirective);


const AllTypes={
description:'All Incidents',
code:null};let


FleetIncidentsDirectiveController=function(_BaseFleetInsightSubV){_inherits(FleetIncidentsDirectiveController,_BaseFleetInsightSubV);
function FleetIncidentsDirectiveController($timeout,$state,$scope,fleetIncidentsDataService,uncaughtErrorHandler,groupTreeService){_classCallCheck(this,FleetIncidentsDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseFleetInsightSubV.call(this,$state,$scope,fleetIncidentsDataService,uncaughtErrorHandler,groupTreeService));

_this2._localTimeZone=_this2._groupBasedDataService.localTimeZone;
_this2.selectedNotificationType=NotificationType.AllThresholdsExceeded;

$scope.$watch('controller.incidentTypes',function(newIncidentTypes,oldIncidentTypes){
if(!_.exists(newIncidentTypes)){
return;
}

const lastSelectedCode=_.get(_this2.selectedIncidentType,'code');
_this2.incidentTypesWithAll=[AllTypes].concat(newIncidentTypes);
if(_.exists(lastSelectedCode)){
_this2.selectedIncidentType=_.find(_this2.incidentTypesWithAll,{code:lastSelectedCode});
}
});

$scope.$watch('controller.selectedGroupData',function(newSelectedGroup,oldSelectedGroup){
if(!_.exists(newSelectedGroup)){
return;
}

for(const person of _this2.selectedGroupData.aggregatePersons){
for(const incident of person.incidents){

incident.currentlyScopedGroupMemberships=person.groupMembershipsAtScope;
}
}

_this2.allIncidents=_.flatten(_this2.selectedGroupData.aggregatePersons.map(function(p){return p.incidents}));
_this2._updateFilteredIncidents();
});

$scope.$watch('controller.selectedIncidentType',function(newSelectedIncidentType,oldSelectedIncidentType){
_this2._updateFilteredIncidents();
});

_this2.filteredIncidents=_this2.allIncidents=[];return _this2;
}FleetIncidentsDirectiveController.prototype.

_updateFilteredIncidents=function _updateFilteredIncidents(){var _this3=this;
if(!_.exists(this.selectedIncidentType)){
return;
}

const{
bucketIndexMap:dateBucketIndexMap}=
DateBucketType.getAllBucketsWithInitialViewData(this.displayInterval,this._localTimeZone);



const _filter=this.selectedIncidentType===AllTypes?
function(i){return dateBucketIndexMap.has(DateBucketType.getBucketFor(i))}:
function(i){return i.code===_this3.selectedIncidentType.code&&dateBucketIndexMap.has(DateBucketType.getBucketFor(i))};

this.filteredIncidents=this.allIncidents.filter(_filter);
};_createClass(FleetIncidentsDirectiveController,[{key:'displayInterval',get:function()

{
return this._groupBasedDataService.displayInterval;
},set:function(

unused){

}},{key:'incidentTypes',get:function()

{
return this._groupBasedDataService.incidentTypes;
}}]);return FleetIncidentsDirectiveController}(BaseFleetInsightSubViewController);


module.exports=FleetIncidentsDirective;
//# sourceMappingURL=fleetIncidentsDirective.js.map
